/**
 * ThreadPresenceBar — small inline indicator showing who else is
 * currently viewing the thread. Stacked initial avatars + label.
 *
 * Uses the same design-token palette as the rest of team chat:
 *   - velBlue avatars at /20 alpha (matches reaction pills, edit input)
 *   - surface for the avatar border so they cut cleanly
 *   - mutedText for the trailing copy
 */
const MAX_SHOW = 4;

const ThreadPresenceBar = ({ presentUuids = [] }) => {
  if (presentUuids.length === 0) return null;

  const visible = presentUuids.slice(0, MAX_SHOW);
  const overflow = presentUuids.length - MAX_SHOW;
  const total = presentUuids.length;

  return (
    <div className="flex items-center gap-x-2 px-3 py-1.5 font-poppins">
      <div className="flex -space-x-1.5">
        {visible.map((uuid) => (
          <div
            key={uuid}
            className="w-5 h-5 rounded-full bg-velBlue/20 border-2 border-surface flex items-center justify-center text-[9px] font-normal text-velBlue"
            title={uuid}
          >
            {uuid.slice(0, 2).toUpperCase()}
          </div>
        ))}
        {overflow > 0 && (
          <div className="w-5 h-5 rounded-full bg-mutedText/20 border-2 border-surface flex items-center justify-center text-[9px] font-normal text-mutedText">
            +{overflow}
          </div>
        )}
      </div>
      <span className="text-[11px] font-light tracking-wide text-mutedText">
        {total === 1 ? "1 other viewing" : `${total} others viewing`}
      </span>
    </div>
  );
};

export default ThreadPresenceBar;
